import { createSlice } from "@reduxjs/toolkit";
import JsonParams from "meta/features/json-params";
const initialState = {
    topMenus: [],
    modifiableMenuItems: [],
};
const applyLogin = (state, data) => {
    state.loggedUsername = data.User.UserOpId;
    state.topMenus = data.StaticData.TopMenus;
    state.modifiableMenuItems = data.StaticData.ModifiableMenuItems;
};
if (JsonParams.LoginResult && JsonParams.LoginResult.Success) {
    applyLogin(initialState, JsonParams.LoginResult.Data);
}
export const rootPublicSlice = createSlice({
    name: "rootPublic",
    initialState,
    reducers: {
        user_login: (state, action) => {
            applyLogin(state, action.payload);
        },
    },
});
export const { user_login } = rootPublicSlice.actions;
export default rootPublicSlice.reducer;
